import ObjectInformation from './component'

export default ObjectInformation
